import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AnalyticsEvent, AnalyticsPage, InternalAnalyticsService } from './internal-analytics.service';
@Injectable({
  providedIn: 'root'
})
export class PageService {
  constructor(private title: Title, private analytics: InternalAnalyticsService) {
    // this.handleIntercomBanner();
  }

  initializePage(pageTitle: string, pageEvent?: AnalyticsPage): void {
    this.title.setTitle(pageTitle);
    if (pageEvent) {
      this.analytics.trackPage(pageEvent);
    }
  }

  private handleIntercomBanner(): void {
    try {
      this.injectIntercomObserver();
    } catch (e) {
      console.warn('Intercom observer failed:', e);
    }

    try {
      this.observeBodyStyleChanges();
    } catch (e) {
      console.warn('Body style observer failed:', e);
    }

    try {
      this.handleResizeEvents();
    } catch (e) {
      console.warn('Resize event setup failed:', e);
    }
  }

  private applyResponsiveBodyStyles(): void {
    if (window.matchMedia('(min-width: 2000px)').matches) {
      document.body.style.marginTop = '0px';
      document.body.style.paddingTop = '48px';
    } else {
      document.body.style.marginTop = '48px';
      document.body.style.paddingTop = '0px';
    }
  }

  private injectIntercomIframeStyle(): void {
    const style = document.createElement('style');
    style.textContent = `
      iframe[name="intercom-banner-frame"] {
        width: 100% !important;
      }
    `;
    document.body.appendChild(style);
  }

  private injectIntercomObserver(): void {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        Array.from(mutation.addedNodes).forEach((node) => {
          if (
            node.nodeType === 1 &&
            (node as HTMLElement).tagName === 'IFRAME' &&
            (node as HTMLIFrameElement).name === 'intercom-banner-frame'
          ) {
            this.injectIntercomIframeStyle();
            observer.disconnect();
          }
        });
      });
    });

    const existing = document.querySelector('iframe[name="intercom-banner-frame"]');
    if (existing) {
      this.injectIntercomIframeStyle();
    } else {
      observer.observe(document.body, {
        childList: true,
        subtree: false
      });
    }
  }

  private observeBodyStyleChanges(): void {
    const observer = new MutationObserver(() => {
      this.applyResponsiveBodyStyles();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  private handleResizeEvents(): void {
    window.addEventListener('resize', () => this.applyResponsiveBodyStyles());
  }
}